import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.83833} fill="#E7EBFA" />
    <G clipPath="url(#clip0_1120_7748)">
      <Path
        opacity={0.2}
        d="M25.8481 21.25V16H11.5981C11.3992 16 11.2085 16.079 11.0678 16.2197C10.9272 16.3603 10.8481 16.5511 10.8481 16.75V27.25C10.8481 27.4489 10.9272 27.6397 11.0678 27.7803C11.2085 27.921 11.3992 28 11.5981 28H13.8481C13.8481 27.4033 14.0852 26.831 14.5072 26.409C14.9291 25.9871 15.5014 25.75 16.0981 25.75C16.6949 25.75 17.2672 25.9871 17.6891 26.409C18.1111 26.831 18.3481 27.4033 18.3481 28H24.3481C24.3481 27.5347 24.4923 27.0808 24.761 26.7008C25.0296 26.3209 25.4094 26.0335 25.8481 25.8784C26.1875 25.7584 26.5508 25.7216 26.9073 25.7711C27.2639 25.8206 27.6034 25.9549 27.8973 26.1627C28.1912 26.3706 28.4309 26.6459 28.5964 26.9656C28.7619 27.2853 28.8482 27.64 28.8481 28H31.0981C31.2971 28 31.4878 27.921 31.6285 27.7803C31.7691 27.6397 31.8481 27.4489 31.8481 27.25V21.25H25.8481Z"
        fill="#1434CB"
      />
      <Path
        d="M26.5981 30.25C27.8408 30.25 28.8481 29.2426 28.8481 28C28.8481 26.7574 27.8408 25.75 26.5981 25.75C25.3555 25.75 24.3481 26.7574 24.3481 28C24.3481 29.2426 25.3555 30.25 26.5981 30.25Z"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.0981 30.25C17.3408 30.25 18.3481 29.2426 18.3481 28C18.3481 26.7574 17.3408 25.75 16.0981 25.75C14.8555 25.75 13.8481 26.7574 13.8481 28C13.8481 29.2426 14.8555 30.25 16.0981 30.25Z"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.3481 28H18.3481"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.8481 28H11.5981C11.3992 28 11.2085 27.921 11.0678 27.7803C10.9272 27.6397 10.8481 27.4489 10.8481 27.25V16.75C10.8481 16.5511 10.9272 16.3603 11.0678 16.2197C11.2085 16.079 11.3992 16 11.5981 16H25.8481V25.8784"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.8481 21.25H21.3481"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.0981 19V23.5"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M25.8481 21.25H31.8481"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M25.8481 17.5H29.84C29.9895 17.4999 30.1355 17.5445 30.2595 17.628C30.3834 17.7116 30.4796 17.8302 30.5356 17.9688L31.8481 21.25V27.25C31.8481 27.4489 31.7691 27.6397 31.6285 27.7803C31.4878 27.921 31.2971 28 31.0981 28H28.8481"
        stroke="#1434CB"
        strokeWidth={1.54056}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1120_7748">
        <Rect
          width={24}
          height={24}
          fill="white"
          transform="translate(8.59839 10)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
